import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EventTracker from "../../utils/EventTracker";
import { GAMES } from "../Game";
import "./GamesCardDark.css";
// import ShowOverlayGame from "./ShowOverlayGame";

export default function GamesCardDark(props) {
  const [showOverLay, setShowOverLay] = useState(false);
  const navigate = useNavigate();

  const onClick = () => {
    if (!props.locked && GAMES.includes(props.type)) {
      localStorage.setItem("gameTrackId", props.id);
      if (
        // !props.overlay &&
        props.slug
      ) {
        navigate(`/games/${props.slug}?aid=${props.aid}`);
      }
      // else {
      //   if (props.overlay || (!props.overlay && !props.slug)) {
      //     setShowOverLay(!showOverLay);
      //   }
      // }
    }

    const properties = {
      Type: "Games Click",
      Game: props.type,
    };
    EventTracker.instance.trackEvent("Games Click", properties);
  };

  return (
    <>
      <div
        className="games-v2-card"
        onClick={onClick}
        key={props.id}
        style={{ backgroundImage: `url(${props.backgroundImage})` }}
      >
        <div
          className="games-v2-card-data"
          style={{ backgroundColor: props.theme }}
        >
          <div>
            <img
              src={props.image}
              style={{
                objectFit: "contain",
                width: `2.5rem`,
                height: `2.5rem`,
                alignSelf: "center",
                display: "flex",
                marginRight: `1rem`,
                // padding: `0.3rem`,
                border: "solid",
                borderRadius: `0.2rem`,
                borderWidth: 1.5,
                borderColor: "white",
              }}
              alt="game-img"
            />
          </div>
          <div>
            <div className="games-v2-title">{props.heading}</div>
            <div className="games-v2-subtitle">{props.text}</div>
          </div>
        </div>
      </div>
      {/* {showOverLay && (
        <ShowOverlayGame
          showOverLay={showOverLay}
          setShowOverLay={setShowOverLay}
          text={props.overlay_text}
        />
      )} */}
    </>
  );
}
